module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-data-source"
  }, [_c('div', [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "select-data-source__icons"
  }, [_vm._l((_vm.availableDatasources), function(dataSource) {
    return [_c('div', {
      key: dataSource.id
    }, [_c('div', [_c('img', {
      staticClass: "select-data-source__icon-def select-data-source__data-icon select-data-source__data-icon--def",
      attrs: {
        "id": ("datasource-id-" + (dataSource.id)),
        "src": _vm.value === dataSource.id ? dataSource.img.selected : dataSource.img.default
      },
      on: {
        "click": function () { return _vm.emit(dataSource.id); }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "select-data-source__title"
    }, [_vm._v(_vm._s(dataSource.title))])])]
  })], 2)])]), _vm._v(" "), (_vm.attachFileEnabled) ? _c('div', {
    staticClass: "select-data-source__atach-a-file"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "select-data-source__attach-button-area"
  }, [_c('action-button', {
    attrs: {
      "dark": _vm.selectedOnFile,
      "label": "Attach A File",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onFile.apply(null, arguments)
      }
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-data-source__select-data-source-area"
  }, [_c('div', [_vm._v("Select Data Source")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-data-source__or-bar"
  }, [_c('hr', {
    staticClass: "select-data-source__border-bar"
  }), _vm._v(" "), _c('span', [_vm._v("OR")]), _vm._v(" "), _c('hr', {
    staticClass: "select-data-source__border-bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b9f4ace"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/createTarget/stepper/SelectDataSource.vue
// module id = 1964
// module chunks = 0